import React, { JSX, useState } from "react";
import {
  Container,
  QuoteCard,
  QuoteCardImage,
  QuoteText,
  UpperInteractiveArea,
  LowerInteractiveArea,
  Icon,
  IconContainer,
  Title,
  Subtitle,
  CardsContainer,
  QuoteCardImageContainer,
  PlayIcon,
} from "./styles";
import ArrowIcon from "../../assets/images/diagonal_arrow.svg";
import { VideoModal } from "./VideoModal";
import playIcon from "../../assets/images/play.svg";
import MarcosImage from "../../assets/images/clean_ingredients/clean-ingredients_real-people_Marcos-Spaziani.png";
import KaylahImage from "../../assets/images/clean_ingredients/clean-ingredients_real-people_Kaylah-Bell.png";
import SageImage from "../../assets/images/clean_ingredients/clean-ingredients_real-people_Sage-E.png";
import ChrisImage from "../../assets/images/clean_ingredients/clean-ingredients_real-people_Chris.png";
import VeenaImage from "../../assets/images/clean_ingredients/clean-ingredients_real-people_Veena.png";

const defaultTitle = "Real People, Real Results";
const defaultSubtitle =
  "Watch lives change weekly on a 30-day plant-based journey - with Beyond as one part of the lifestyle shift.";
const defaultCards = [
  {
    id: "1",
    image: MarcosImage,
    text: "“My cholesterol dropped, and my sleep is better!”",
    button: "View Marcos' journey",
    video: "https://www.youtube.com/embed/0Ld_qcgyVe4",
    link: "https://www.youtube.com/playlist?list=PL5Tw0nRgLGNHrYF4eC80j64DhrE9n4ETb ",
  },
  {
    id: "2",
    image: KaylahImage,
    text: "“I don't have to deprive myself of foods I love.”",
    button: "View Kaylah's journey",
    video: "https://www.youtube.com/embed/wNqy4qrY1fk",
    link: "https://www.youtube.com/playlist?list=PL5Tw0nRgLGNGFv26S8-qreWfTdWjNrPkS",
  },
  {
    id: "3",
    image: SageImage,
    text: "“As a 2x US Open Surfing champ, I'm blown away.”",
    button: "View  Sage's Journey",
    video: "https://www.youtube.com/embed/zqdkA3dSGos",
    link: "https://www.youtube.com/playlist?list=PL5Tw0nRgLGNFFKoRcV3bCP7SHMdAoN9WK",
  },
  {
    id: "4",
    image: ChrisImage,
    text: "“This plant-based diet may be here to stay.”",
    button: "View  Chris's Journey",
    video: "https://www.youtube.com/embed/YTeSEe_24Bw",
    link: "https://www.youtube.com/playlist?list=PL5Tw0nRgLGNG9qUhD7NGbVjY5-dQZ7eVK",
  },
  {
    id: "5",
    image: VeenaImage,
    text: "“This was the most life-changing 30 days I've ever had.”",
    button: "View  Veena's Journey",
    video: "https://www.youtube.com/embed/kGO9FbPcve4",
    link: "https://www.youtube.com/playlist?list=PL5Tw0nRgLGNEfOqUF2296ias6411tXVV8",
  },
];

export type QuoteCardsProps = {
  title?: string;
  subtitle?: string;
  cards?: {
    id: string;
    image: string;
    text: string;
    button: string;
    link: string;
    video: string;
  }[];
  backgroundColor?: string;
  color?: string;
};

const QuoteCards = ({
  title = defaultTitle,
  subtitle = defaultSubtitle,
  cards = defaultCards,
  backgroundColor = "#FDC04E",
  color = "var(--color-green-90)",
}: QuoteCardsProps): JSX.Element => {
  const [selectedVideo, setSelectedVideo] =
    useState<string | null>(null);
  return (
    <>
      {selectedVideo && (
        <VideoModal
          src={selectedVideo}
          onClose={() => setSelectedVideo(null)}
        />
      )}
      <Container
        className="bg-color-dark-green"
        backgroundColor={backgroundColor}
        color={color}
      >
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
        <CardsContainer>
          {cards.map((card) => (
            <QuoteCard key={card.id}>
              <UpperInteractiveArea
                type="button"
                aria-label="Play video"
                onClick={() =>
                  setSelectedVideo(card.video)
                }
              >
                <QuoteCardImageContainer
                  onClick={() => setSelectedVideo(card.video)}
                >
                  <QuoteCardImage src={card.image} />
                  <PlayIcon>
                    <img src={playIcon} alt="play" />
                  </PlayIcon>
                </QuoteCardImageContainer>
                <QuoteText>{card.text}</QuoteText>
              </UpperInteractiveArea>
              <LowerInteractiveArea target="_blank" href={card.link}>
                {card.button}
                <IconContainer>
                  <Icon src={ArrowIcon} />
                </IconContainer>
              </LowerInteractiveArea>
            </QuoteCard>
          ))}
        </CardsContainer>
      </Container>
    </>
  );
};

export default QuoteCards;
